import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AnimationReunion, AnimationReunionAll } from '@app/models/animationReunion';
import { ContratAccueilMentalo, EnfantMentalo } from '@app/models/contrat-accueil';
import { PlatformService, SnackbarService, UserService } from '@app/services';
import { AssmatService } from '@app/services/assmat.service';
import moment from 'moment';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-inscription-animations',
  templateUrl: './inscription-animations.component.html',
  styleUrls: ['./inscription-animations.component.scss']
})
export class InscriptionAnimationsComponent implements OnInit {

  idAssmat: number;
  listAnimations: AnimationReunion[];
  listAnimationsFiltered: AnimationReunion[];
  listChildWithContratEnabled: EnfantMentalo[];
  saving = false;
  drawerOpened = false;
  RegisterChildDialogRef: MatDialogRef<any>;
  registerChildList: number[];
  filters = {
    search: "",
    etablissement: 0,
    fromDate: "",
    toDate: ""
  };

  @ViewChild('RegisterChildDialog', { static: true }) RegisterChildDialog: TemplateRef<any>;

  constructor(
    private assmatService: AssmatService,
    private userService: UserService,
    private matDialog: MatDialog,
    private platformService: PlatformService,
    private snackbar: SnackbarService,
  ) { }

  ngOnInit(): void {
    this.idAssmat = this.userService.currentUser.idAssmat || null;
    this.loadAnimations();
  }

  loadAnimations() {
    forkJoin([
      this.assmatService.getAnimationsByIdAssmat(this.idAssmat),
      this.assmatService.getEnfantsMentaloByIdAssMat(this.idAssmat),
      this.assmatService.getContratsAccueilByIdAssMat(this.idAssmat)
    ]).subscribe(([listAnim, childList, contrats]: [AnimationReunionAll, EnfantMentalo[], ContratAccueilMentalo[]]) => {

      this.listChildWithContratEnabled = [];
      this.listAnimations = listAnim.tabAvailable.filter(anim => moment(anim.date) >= moment(new Date()));
      this.listAnimationsFiltered = this.listAnimations;
      // this.listAnimations = this.assmatService.sortByDate(this.listAnimations);
      this.listChildWithContratEnabled = this.assmatService.getChildListWithContratEnable(contrats, childList);
    })
  }

  openRegisterChildDialog(listChild, animation) {
    this.RegisterChildDialogRef = this.matDialog.open(this.RegisterChildDialog, {
      data: { listChild, animation },
      maxWidth: '700px',
      minWidth: 'min(500px, 100%)',
      panelClass: this.platformService.isMobile ? 'full-screen-dialog' : '',
    });

    this.platformService.adaptDialogToScreen(this.RegisterChildDialogRef);

    this.RegisterChildDialogRef.afterClosed().subscribe(_ => {
      this.registerChildList = [];
    });
  }

  clickToConfirm(animationReunion: AnimationReunion) {

    let animationReunionPortail = {
      idAnimation: animationReunion.idAnimation,
      idAssmat: this.idAssmat,
    }

    this.saving = true;
    this.assmatService.inscriptionAnimationReunion(
      this.idAssmat, {
      idPortailAnimationReunionAssmat: animationReunion.portailInscription?.idPortailAnimationReunionAssmat,
      selectedChild: this.registerChildList,
      animationReunionPortail
    }).subscribe(_ => {
      animationReunion.saving = true;
      this.loadAnimations();
      this.RegisterChildDialogRef.close();
      this.registerChildList = [];
      this.saving = false;
      this.snackbar.info('Inscription Réussie');
    }, err => this.snackbar.error('Erreur lors de l\'inscription'))
  }

  cancel() {
    this.RegisterChildDialogRef.close();
    this.registerChildList = [];
  }

  closeDrawer() {
    this.drawerOpened = false;
  }

  toggleAnimationsOptions() {
    this.drawerOpened = !this.drawerOpened;
  }

  changeFilter(event) {
    if (event) {
      this.listAnimationsFiltered = this.listAnimations.filter(animation => {
        return (animation.titre.toLowerCase().includes(this.filters.search.toLowerCase()) || this.filters.search === '') &&
          (moment(animation.date) >= moment(this.filters.fromDate) || !moment(this.filters.fromDate).isValid()) &&
          (moment(animation.date) <= moment(this.filters.toDate) || !moment(this.filters.toDate).isValid());
      })
    }
  }

}
